import React, { useEffect, useRef } from "react";
import { EonUiInput } from "@eon-ui/eon-ui-components-react";

type ExpandingInputProps = Omit<
    React.ComponentProps<typeof EonUiInput>,
    "value"
> & {
    value: string;
};

export const ExpandingInput = (props: ExpandingInputProps) => {
    const { value, ...restProps } = props;
    const divRef = useRef<HTMLDivElement | null>(null);
    const inputRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        const getInputRef = async () => {
            if (!divRef.current) return;
            const eonInputEl = divRef.current.querySelector("eon-ui-input");
            let eonTextarea = null;
            let eonTextareaNavigation = null;
            while (eonTextarea === null) {
                eonTextarea =
                    eonInputEl?.shadowRoot?.querySelector("textarea") ?? null;
                eonTextareaNavigation = eonInputEl?.shadowRoot?.querySelector(".eonui-navigation-elements")?? null;
                if (eonTextarea) {
                    eonTextarea.style.height = "auto";
                    eonTextarea.style.minHeight = "40px";
                    eonTextarea.style.maxHeight = "30vh";
                    eonTextarea.style.overflow = "auto";
                    eonTextarea.style.resize = "none";
                    eonTextarea.style.height = `${eonTextarea.scrollHeight}px`;
                }
                if (eonTextareaNavigation) {
                    (eonTextareaNavigation as HTMLElement).style.display = "none";
                }
                await new Promise((resolve) => setTimeout(resolve, 100));
            }
            inputRef.current = eonTextarea as HTMLTextAreaElement | null;
        };
        if (divRef.current) {
            if (inputRef.current) {
                const el = inputRef.current;
                if (!el) return;
                const resize = () => {
                    el.style.height = "auto";
                    el.style.height = `${el.scrollHeight}px`;
                };
                resize();
                window.addEventListener("resize", resize);
                return () => window.removeEventListener("resize", resize);
            } else {
                getInputRef();
            }
        }
    }, [value]);

    return (
        <div ref={divRef}>
            <EonUiInput
                value={value}
                size="normal"
                rows={1}
                textarea
                {...restProps}
            />
        </div>
    );
};
